import React, { Component } from 'react';
import './Register.css';
import {connect} from "react-redux";
import {Col, Row} from 'reactstrap';


import { Card, CardBody,
    CardTitle} from 'reactstrap';

import LoginCheck from '../../shared/LoginCheck';
import NavBar from '../../shared/NavBar';


class Register extends Component {

    constructor(props) {
        super(props);
        this.state = {
            "method":"create",
            "first_name": "",
            "last_name": "",
            "email": "",
            "password": "",
            "verify_password": ""
        };

        this.loginCheck();
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    loginCheck(){

        let MyCheck = LoginCheck();
        if (MyCheck.loggedIn === true){

            if (this.props.state.loggedIn === false){
                this.props.dispatch(
                    {
                        "type":"SET_USER_DATA",
                        "user": MyCheck.user
                    });
            }

        } else {
            window.location = '#/login';
        }
    }

    handleChange(event) {

        const target = event.target;
        const name = target.name;

        this.setState({
            [name]:target.value
        });


    }

    handleSubmit(event) {
        this.makeApiCall();
        event.preventDefault();
    }

    makeApiCall(){

        fetch('https://api.iondeveloper.com/admin/user/', {
            method: 'post',
            body: JSON.stringify(
                    {
                        "method":"create",
                        "first_name": this.state.first_name,
                        "last_name": this.state.last_name,
                        "email": this.state.email,
                        "password": this.state.password,
                        "verify_password": this.state.verify_password
                    }
                )
        }).then(function(response) {
            return response.json();
        }).then(function(data) {

            if (data.success === true){
                alert("user created");
            } else {
                console.log(data);
            }

        });

    }

    render() {

        return (
            <div className="login-bg-color">
                <NavBar />
                <div className="container">
                    <Row>
                        <Col sm="3">
                        </Col>
                        <Col sm="6">
                            <Card className="registerCard">
                                <CardBody>
                                    <CardTitle>Create new web user</CardTitle>
                                    <div className="form-container register-form">
                                        <form >
                                            <label htmlFor="">First Name</label>
                                            <input className="standard-input" type="text" name="first_name" value={this.state.first_name} onChange={this.handleChange} placeholder="First Name" />
                                            <label htmlFor="">Last Name</label>
                                            <input className="standard-input" type="text" name="last_name" value={this.state.last_name} onChange={this.handleChange} placeholder="Last Name" />
                                            <label htmlFor="">Email</label>
                                            <input className="standard-input" type="email" name="email" value={this.state.email} onChange={this.handleChange} placeholder="Email" />
                                            <label htmlFor="">Password</label>
                                            <input className="standard-input" type="password" name="password" value={this.state.password} onChange={this.handleChange}  placeholder="Password" />
                                            <label htmlFor="">Verify Password</label>
                                            <input className="standard-input" type="password" name="verify_password" value={this.state.verify_password} onChange={this.handleChange} placeholder="Retype Password" />
                                            <button type="button" className="form-submit" onClick={this.handleSubmit} >Submit</button>
                                        </form>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col sm="3">
                        </Col>
                    </Row>


                </div>


            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        state: state
    };
}

export default connect(mapStateToProps)(Register);


// WEBPACK FOOTER //
// ./src/components/pages/Register/Register.js